import { mediaInfoPoviders } from './mockedData'

export const fetchMessagesProviders = () => [null, { data: mediaInfoPoviders }]
